import { useTranslation } from 'react-i18next'

import * as Styles from './styles'

const ProductsSelectionMessage = ({ selectedItems = [] }) => {
  const { t } = useTranslation()

  return (
    <Styles.SelectProductsText>
      {t(
        selectedItems?.length > 0
          ? 'Ya has seleccionado productos. Continúa para completar tu devolución.'
          : 'Selecciona al menos un producto para continuar:'
      )}
    </Styles.SelectProductsText>
  )
}

export default ProductsSelectionMessage
